module.exports = __webpack_public_path__ + "static/media/honeycomb.578f0c0a.svg";